import {Checkbox, Form} from 'antd';
import classNames from 'classnames';
import set from 'lodash/set';
import PropTypes from 'prop-types';
import React, {memo, useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import InfoBox from '@/components/InfoBox';
import UploadFileDragger from '@/components/UploadFileDragger';

const ProposalTrademark = ({
  value,
  onChange,
  label,
  translate,
  descriptionText = 'proposalRequest.form.general.haveTradeMark.upload',
  helpText = 'proposalRequest.form.general.haveTradeMark.help',
  showHelp = true,
  ...rest
}) => {
  const {t} = useTranslation(translate || 'common');
  let [data, setData] = useState(value || {});
  const [form] = Form.useForm();
  const upload = useRef();

  useEffect(() => {
    if (value) {
      setData(value || {});
    }
  }, [value]);

  const onChangeValue = useCallback((value, key) => {
    set(data, key, value);
    setData({...data});
    onChange && onChange({...data});
  }, [data, onChange]);

  const onActiveChange = useCallback((e) => {
    onChangeValue(e?.target?.checked, 'active');
    if (!e?.target?.checked) {
      onChangeValue(null, 'file');
      form.resetFields();
    }
  }, [form, onChangeValue]);

  const onFileChange = useCallback((e) => {
    onChangeValue(e, 'file');
  }, [onChangeValue]);

  return (
    <>
      <div className="mb-2 mt-4">
        <Checkbox
          checked={data?.active}
          className={classNames('mx-0 my-px')}
          size={'large'}
          onChange={onActiveChange}>{t(label)}</Checkbox>
        {(!data?.active && showHelp) &&
          <InfoBox title={helpText} translate={translate}
            className="md:mb-0"/>}
      </div>
      {!!data?.active && <>
        <UploadFileDragger
          {...rest}
          value={data?.file}
          disabled={!data?.active}
          isImage={false}
          translation={translate}
          innerRef={upload}
          listType={'picture'}
          onChange={onFileChange}
          descriptionText={descriptionText}/>
        {!!showHelp && <InfoBox title={helpText} translate={translate} className="md:mb-0"/>}
      </>}
    </>
  );
};

ProposalTrademark.propTypes = {
  value: PropTypes.object,
  translate: PropTypes.string,
  maxCount: PropTypes.number,
  multiple: PropTypes.bool,
  helpText: PropTypes.string,
  showHelp: PropTypes.bool,
  label: PropTypes.string,
  descriptionText: PropTypes.string,
  onChange: PropTypes.func
};

ProposalTrademark.defaultProps = {
  maxCount: 1
};

export default memo(ProposalTrademark);
